var React = require('react');

function IconStorefront (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23 8.75962V7.20518C23 6.98641 22.908 6.76763 22.747 6.60643L18.63 2.55337C18.469 2.39216 18.239 2.30005 18.009 2.30005L4.8875 2.31156C4.692 2.31156 4.508 2.39216 4.3815 2.51882L0.2185 6.62946C0.0805 6.76763 0 6.96338 0 7.15912V8.72508C0 8.98991 0.2185 9.20868 0.483 9.20868H2.3115V18.3972H0.3795C0.184 18.3972 0.023 18.5584 0.023 18.7541V20.2855C0.023 20.5158 0.207 20.6885 0.4255 20.6885H22.5285C22.7815 20.6885 22.9885 20.4813 22.9885 20.228V18.8462C22.9885 18.5929 22.7815 18.3857 22.5285 18.3857H20.6885V9.20868H22.5745C22.8045 9.20868 23 9.00143 23 8.75962ZM11.4885 9.20868V16.0943H4.6V9.20868H11.4885ZM18.3885 18.3972H13.8V9.20868H18.3885V18.3972Z"}));
}

IconStorefront.defaultProps = {"width":"23","height":"23","viewBox":"0 0 23 23","fill":"none"};

module.exports = IconStorefront;

IconStorefront.default = IconStorefront;
